import { API_ENDPOINTS } from '@/api/endpoints';
import { Area } from '@/stores/SubprojectStore';
import { apiFetch } from '@/util/apiClient';
import { useQuery } from '@tanstack/react-query';
import { WaterHeater, WaterHeaterWithMetrics } from '../types';
import { addMetricsToResource } from './techMetrics';

export const useWaterHeaterWithMetrics = (conditionedSpaceArea?: Area) => {
  return useQuery<WaterHeater[], Error, WaterHeaterWithMetrics[]>({
    queryKey: ['waterheater', 'withMetrics', conditionedSpaceArea?.value],
    queryFn: () =>
      apiFetch<WaterHeater[]>(API_ENDPOINTS.COMMON.technology.waterheater),
    enabled: conditionedSpaceArea !== undefined,
    select: (data) => addMetricsToResource(data, conditionedSpaceArea),
  });
};
